module.exports = __webpack_public_path__ + "img/20220420144547.ffa315a2.png";